/*
  AddressBookRequest.js - Networking for the Address Book content
*/

// OUR MODULES
import RequestRabbit from './RequestRabbit';

// CONFIG
import config from '../Config';

const useAddressBookRequest = () => {
  /*
  New functionality for the addressbook
  */
  const getSmsContacts = async (errorHandler, params) => {
    try {
      let url = `${config.baseServerURL}/addressbook/contacts?`;
      if (params?.searchContent) url = url + `content=${params?.searchContent}`;
      if (params?.global) url = url + `&global=${params.global}`;
      if (params?.personal) url = url + `&personal=${params.personal}`;
      if (params?.distListId) url = url + `&distListId=${params?.distListId}`;

      const options = {
        method: 'GET',
      };

      // Get sms contact
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (err) {
      errorHandler(err);
    }
  };

  /*
    Takes a Contact Object and sends it as a POST request to the back-end in order to
    insert a new Contact.
    Inputs:
      - contact: Requires first_name, last_name, email, number and entry_type.
        Optionals are middle_name
    Outputs:
      - Newly inserted Contact Object
  */
  const createNewSmsContact = async (contact, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/addressbook/contacts`;
      const body = JSON.stringify(contact);
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        headers: headers,
        body: body,
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
      return e;
    }
  };

  const upgradeContactToGlobal = async (contact, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/addressbook/contacts/upgrade`;
      const body = JSON.stringify(contact);
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        headers: headers,
        body: body,
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  const updateSmsContact = async (
    smsContactId,
    contactType,
    update,
    errorHandler
  ) => {
    try {
      const url = `${config.baseServerURL}/addressbook/contacts/${smsContactId}?contactType=${contactType}`;
      const body = JSON.stringify(update);
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        headers: headers,
        body: body,
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();
      console.log('update sms contact', response);

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  const deleteContact = async (smsContactId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/addressbook/contacts/${smsContactId}`;
      const options = {
        method: 'DELETE',
      };

      // Request
      await RequestRabbit.request(url, options, errorHandler);
    } catch (e) {
      errorHandler(e.message);
    }
  };

  const deleteSelectedSmsContacts = async (smsContactList, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/addressbook/contacts/delete`;
      const body = JSON.stringify(smsContactList);
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        headers: headers,
        body: body,
      };

      await RequestRabbit.request(url, options, errorHandler);
    } catch (e) {
      errorHandler(e.message);
    }
  };

  const exportContacts = async (data, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/addressbook/contacts/export`;
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      if (response?.status === 200) {
        let downloadUrl = `${config.baseServerURL}/addressbook/download/${responseJSON.filename}`;
        window.open(downloadUrl);
      }
    } catch (e) {
      errorHandler(e);
    }
  };

  const getDistLists = async (errorHandler, params) => {
    try {
      let url = `${config.baseServerURL}/addressbook/lists?`;
      if (params?.searchContent) url = url + `content=${params?.searchContent}`;
      if (params?.global) url = url + `&global=${params.global}`;
      if (params?.personal) url = url + `&personal=${params.personal}`;
      const options = {
        method: 'GET',
      };

      // Get sms contact
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (err) {
      errorHandler(err);
    }
  };

  const getDistListContacts = async (distListId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/addressbook/lists/` + distListId;
      const options = {
        method: 'GET',
      };

      // Get sms contact
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (err) {
      errorHandler(err);
    }
  };

  const addDistList = async (newDistList, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/addressbook/lists`;
      const body = JSON.stringify(newDistList);
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        headers: headers,
        body: body,
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  const editDistList = async (distListEdits, distListId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/addressbook/lists/` + distListId;
      const body = JSON.stringify(distListEdits);
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        headers: headers,
        body: body,
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  const deleteSelectedDistLists = async (distListIds, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/addressbook/lists/delete`;
      const body = JSON.stringify(distListIds);
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        headers: headers,
        body: body,
      };

      await RequestRabbit.request(url, options, errorHandler);
    } catch (e) {
      errorHandler(e.message);
    }
  };

  const getBlacklistItems = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/addressbook/blacklist/`;
      const options = {
        method: 'GET',
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  const getAddressbookCounts = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/addressbook/count`;
      const options = {
        method: 'GET',
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  /*
    Deletes ALL Personal Contacts for the calling Customer User
  */
  const deleteAllContacts = async (selected, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/addressbook/contacts/delete/${selected}`;
      const options = {
        method: 'DELETE',
      };

      // Update Contact
      let response = await RequestRabbit.request(url, options, errorHandler);
      if (response?.status === 204) return true;
      errorHandler('Failed to delete all Contacts of type ' + selected);
    } catch (err) {
      errorHandler(err);
    }
  };

  /*
    Update global blacklist
  */
  const updateBlacklistGlobal = async (data, errorHandler) => {
    const url = `${config.baseServerURL}/addressbook/blacklist/${data.blacklistId}`;
    const body = JSON.stringify(data);
    const headers = new Headers({
      'Content-Type': 'application/json',
    });
    const options = {
      method: 'POST',
      headers: headers,
      body: body,
    };

    try {
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  /*
    Takes a blacklist Object and sends it as a POST request to the back-end in order to
    insert a new global blacklist record.
    @param blacklistId: customer blacklist Id
    @param data: 'number':'610123456789','entry_type':('global'/'personal')
    @return
      - Newly inserted Blacklist Object
  */
  const insertBlacklistGlobal = async (data, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/addressbook/blacklist/`;
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
      };

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);

      // Response
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  /*
    Delete blacklist item
  */
  const deleteBlackList = async (blacklistId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/addressbook/blacklist/${blacklistId}`;
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'DELETE',
        headers: headers,
      };

      // Request
      await RequestRabbit.request(url, options, errorHandler);
    } catch (e) {
      console.log(e.message);
    }
  };

  const exportDistList = async (distListId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/addressbook/lists/csv/` + distListId;
      const options = {
        method: 'GET',
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      if (response?.status === 200) {
        console.log(responseJSON);
        let downloadUrl = `${config.baseServerURL}/addressbook/download/${responseJSON.filename}`;
        window.open(downloadUrl);
      }
    } catch (e) {
      errorHandler(e);
    }
  };

  // Export functions as a module
  return {
    getSmsContacts,
    createNewSmsContact,
    upgradeContactToGlobal,
    updateSmsContact,
    deleteContact,
    deleteSelectedSmsContacts,
    exportContacts,
    getDistLists,
    getDistListContacts,
    addDistList,
    editDistList,
    deleteSelectedDistLists,
    getBlacklistItems,
    getAddressbookCounts,
    deleteAllContacts,
    updateBlacklistGlobal,
    insertBlacklistGlobal,
    deleteBlackList,
    exportDistList,
  };
};
export default useAddressBookRequest;
